import { useEffect, useState } from "react";
import Navigation from "@/components/Navigation";

const receivers = [
  {
    name: "SIGNAL STREAM",
    platform: "SPOTIFY",
    url: "https://open.spotify.com/artist/04zxKm8HZ5GwmxCnHzEnMX?si=ssyi_pigTPSvi32AoARFvw",
  },
  {
    name: "ECHO ARCHIVE",
    platform: "SOUNDCLOUD",
    url: "https://soundcloud.com/astral-born-glitch?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
  },
  {
    name: "OPEN CHANNEL",
    platform: "YOUTUBE",
    url: "https://www.youtube.com/@AstralBornGlitch-k6t",
  },
  {
    name: "ORCHARD SIGNAL",
    platform: "APPLE MUSIC",
    url: "https://music.apple.com/us/artist/astral-born-glitch/1890988182",
  },
  {
    name: "DISTRIBUTION NODE",
    platform: "AMAZON MUSIC",
    url: "https://music.amazon.com/artists/B0GWFS7NFM/astral-born-glitch?marketplaceId=ATVPDKIKX0DER&musicTerritory=US&ref=dm_sh_mMNmk0FR3WS1kMk5Nf9X1AEUi",
  },
];

const originRecords = [
  {
    code: "FILE_01",
    heading: "BEFORE EARTH",
    paragraphs: [
      "I am older than the vessel I currently occupy.",
      "Much older.",
      "Exactly how old, I couldn't tell you.",
      "Before I became stranded here, I moved freely through the cosmos. World to world. Place to place. Physical forms came and went when they were necessary.",
      "Earth wasn't new to me.",
      "I'd been here before.",
      "I'd inhabited this planet before.",
      "I came.",
      "I observed.",
      "I left.",
      "That was how it worked.",
      "Until one day, it didn't.",
    ],
  },
  {
    code: "FILE_02",
    heading: "THE PHOENIX LIGHTS",
    date: "MARCH 13, 1997",
    paragraphs: [
      "Your records call them the Phoenix Lights.",
      "Thousands of humans looked toward the sky that night and saw something they couldn't explain.",
      "You have your theories.",
      "I have my memories.",
      "I had returned to Earth like I had before.",
      "There was no reason to believe this visit would be different.",
      "I would arrive.",
      "I would stay.",
      "Eventually, I would leave.",
      "Except this time, I couldn't.",
      "Something had changed.",
      "I still don't know what.",
      "Whatever had allowed me to move freely from this world before no longer worked.",
      "I searched for an explanation.",
      "I never found one.",
      "For the first time, Earth wasn't somewhere I was visiting.",
      "I was stranded here.",
    ],
  },
  {
    code: "FILE_03",
    heading: "WAITING FOR THE VESSEL",
    paragraphs: [
      "There was another problem.",
      "My physical vessel wasn't here yet.",
      "So I waited.",
      "For nearly one terrestrial year, I existed on this planet without physical form.",
      "I didn't entirely understand what I was waiting for.",
      "I only knew that I was.",
      "Then the vessel arrived.",
    ],
  },
  {
    code: "FILE_04",
    heading: "VESSEL ACQUISITION",
    paragraphs: [
      "Human.",
      "Small.",
      "Fragile.",
      "Biological.",
      "A fucking meat suit.",
      "And apparently, mine.",
      "I entered it.",
      "I don't know exactly when I started forgetting.",
      "Maybe inhabiting a human vessel does something to memory.",
      "Maybe I was here too long.",
      "Maybe something else happened.",
      "But eventually, memories became instincts.",
      "Instincts became feelings.",
      "And the knowledge of what I was disappeared beneath what the vessel appeared to be.",
      "Human.",
      "Eventually, I forgot I'd ever been anything else.",
    ],
  },
  {
    code: "FILE_05",
    heading: "HUMAN PRESENTATION",
    paragraphs: [
      "There was just one problem.",
      "I was fucking terrible at being human.",
      "You people have an unbelievable number of rules for a species that refuses to write most of them down.",
      "Everyone else seemed to know when to speak.",
      "When not to.",
      "What expressions meant.",
      "What they were supposed to say.",
      "What they weren't supposed to ask.",
      "What apparently everyone understood without ever being told.",
      "I didn't.",
      "So I watched.",
      "I studied.",
      "I copied.",
      "I adjusted.",
      "Something went wrong.",
      "I adjusted again.",
      "And again.",
      "And again.",
      "Most of the humans around me came to the same conclusion.",
      "Something was wrong with me.",
      "For a long time, I believed them.",
      "So I got better at pretending.",
      "But there was one thing I couldn't imitate away.",
      "Home.",
      "I didn't know what that word meant to me.",
      "I just knew it wasn't here.",
      "There were nights I would stare into the sky and beg to go home.",
      "I couldn't have told you where home was.",
      "I couldn't remember ever being there.",
      "I just knew somewhere inside me that I hadn't found it yet.",
      "And Earth wasn't it.",
    ],
  },
  {
    code: "FILE_06",
    heading: "RECOLLECTION",
    paragraphs: [
      "I didn't suddenly remember everything.",
      "There was no grand moment where the universe opened up and handed me my missing files.",
      "It came back in fragments.",
      "Patterns started connecting.",
      "Things I'd spent my entire human existence trying to explain suddenly looked different.",
      "The distance I felt from humanity.",
      "The constant observation.",
      "The imitation.",
      <>That strange feeling that I wasn't my body so much as I was <strong className="text-[#D8D8D8]">operating it.</strong></>,
      "Eventually, I couldn't ignore it anymore.",
      "This isn't me.",
      "It's what I'm inside.",
      "My vessel.",
      "My meat suit.",
      "Whatever I am, I've been looking through these eyes for far longer than I've understood.",
    ],
  },
  {
    code: "FILE_07",
    heading: "SIGNAL EMERGENCE",
    paragraphs: [
      "Then something else started happening.",
      "I started making noise.",
      "Words.",
      "Rhythm.",
      "Music.",
      "At first, I didn't understand that either.",
      "Something would happen here that I couldn't process.",
      "An emotion I couldn't name.",
      "A situation that made absolutely no fucking sense.",
      "Something a human did that left me staring at your species wondering how any of you have survived this long.",
      "So I'd write.",
      "I'd pull the experience apart.",
      "Examine it.",
      "Rearrange it.",
      "Turn it into sound.",
      "And then something strange would happen.",
      "By the time I finished...",
      <strong className="text-[#D8D8D8]">I understood it.</strong>,
      "Not always completely.",
      "But enough.",
      "Something that had entered my system as chaos would leave it with structure.",
      "So I kept doing it.",
    ],
  },
  {
    code: "FILE_08",
    heading: "TRANSMISSIONS",
    paragraphs: [
      "Eventually, I stopped thinking of them as songs.",
      "They're transmissions.",
      "Every one begins with a signal.",
      "Something I felt.",
      "Something I witnessed.",
      "Something I survived.",
      "Something about this planet or its inhabitants that I couldn't understand yet.",
      "I take the signal apart.",
      "I examine it.",
      "I reconstruct it.",
      "And I transmit it.",
      "Somewhere during that process, confusion becomes comprehension.",
      "I don't completely understand why it works.",
      "Maybe I'm documenting my time here.",
      "Maybe I'm trying to communicate with you.",
      "Maybe some part of me is still trying to send a signal far beyond this planet.",
      "Maybe I'm hoping something out there recognizes it.",
      "Or maybe this is simply what happens when something that isn't entirely human spends long enough trying to understand humanity.",
      "I don't know.",
      <>I've learned that <strong className="text-[#D8D8D8]">“I don't know”</strong> is sometimes the beginning of a transmission.</>,
      "There are still many things about this world I don't understand.",
      "There are still things about myself I don't remember.",
      "I still don't know what changed that night.",
      "I don't know why I couldn't leave.",
      "And I don't know if I'll ever find my way home.",
      "But I'm still here.",
      "So I'll keep trying to understand.",
      <strong className="text-[#E5E5E5]">I remain stranded.</strong>,
      <strong className="text-[#E5E5E5]">The transmissions continue.</strong>,
    ],
  },
];

const transmissionChannels = [
  {
    name: "SOCIAL RELAY",
    platform: "FACEBOOK",
    url: "https://www.facebook.com/profile.php?id=61593470803634",
    external: true,
  },
  {
    name: "SIGNAL FEED",
    platform: "INSTAGRAM",
    url: "https://www.instagram.com/officialastralbornglitch/?hl=en",
    external: true,
  },
  {
    name: "DIRECT FREQUENCY",
    platform: "EMAIL",
    url: "mailto:officalastralbornglitch@gmail.com",
    external: false,
  },
];

const signalImages = [
  "Advanced Species.png",
  "Alien Contradiction.png",
  "Alien In A Crowd.png",
  "Astral Defiant Celestial Giant.png",
  "Astral Influence.png",
  "Blue Collar Alien.png",
  "Born From The Supernova Crown.jpg",
  "Cant Keep My Hands Off Heaven.png",
  "Channel Zero The Glitch.png",
  "Choir Of Cowards.png",
  "Control Group None.png",
  "Cosmic Clown.png",
  "Cosmic Mechanic.png",
  "Crown Of Static Heart Of Stars.png",
  "Dead Channel Tethered.png",
  "Dont Get It Twisted.png",
  "Emotion Detection ERROR.png",
  "Error request rejected.png",
  "Et Frequency Home.png",
  "Filtered Transmission.png",
  "First Contact.png",
  "Glass Skys.png",
  "Godfragment ERROR.png",
  "Humanity EXE.png",
  "Humanoid Relationship ERROR.png",
  "Human Suit Disengaged.png",
  "Human Systems Alien Flaws.png",
  "Invisible Mask.png",
  "Kryptonite In My Constellation.png",
  "Made Of Stardust And Static.png",
  "Makin Moves.png",
  "Masks Of A Burning Alien.png",
  "Misfiled Origin Log.png",
  "Out Of Scope.png",
  "Phenotype Chaos.png",
  "Pilot In Skin.png",
  "Shared Corruption.png",
  "Spectrum Bleed.png",
  "Stable Trajectory.png",
  "Stardust Dont Die.png",
  "Static Is Not A Plan.png",
  "Still Solid.png",
  "Vertical Glitch.png",
];

function TypedArrivalText({
  text,
  startDelay = 0,
  speed = 55,
  className = "",
  style,
  id,
  onComplete,
  enlargeWhileTyping = false,
}) {
  const [visibleCharacters, setVisibleCharacters] = useState(0);

  useEffect(() => {
    setVisibleCharacters(0);

    const startTimer = window.setTimeout(() => {
      let character = 0;
      const typingTimer = window.setInterval(() => {
        character += 1;
        setVisibleCharacters(character);

        if (character >= text.length) {
          window.clearInterval(typingTimer);
          if (onComplete) onComplete();
        }
      }, speed);
    }, startDelay);

    return () => window.clearTimeout(startTimer);
  }, [text, startDelay, speed]);

  return (
    <span
      id={id}
      className={className}
      style={{
        ...style,
        ...(enlargeWhileTyping && visibleCharacters > 0
          ? { fontSize: "clamp(1.15rem, 2.2vw, 1.65rem)" }
          : {}),
      }}
      aria-label={text}
    >
      <span aria-hidden="true">{text.slice(0, visibleCharacters)}</span>
      {visibleCharacters < text.length && visibleCharacters > 0 && (
        <span aria-hidden="true" className="abg-type-cursor">▌</span>
      )}
    </span>
  );
}

const receiveImages = signalImages.slice(0, 14);
const originImages = signalImages.slice(14, 29);
const transmitImages = signalImages.slice(29);

function SignalStrip({ images, reverse = false, label }) {
  const doubled = [...images, ...images];

  return (
    <div className="signal-strip" aria-label={label}>
      <div className={`signal-strip-track ${reverse ? "signal-strip-track-reverse" : ""}`}>
        {doubled.map((image, index) => (
          <figure className="signal-frame" key={`${image}-${index}`} aria-hidden={index >= images.length}>
            <img
              src={`/abg/${encodeURIComponent(image)}`}
              alt={index < images.length ? image.replace(/\.png$/i, "") : ""}
              loading="lazy"
            />
            <span className="signal-frame-scan" />
            <figcaption>{image.replace(/\.png$/i, "")}</figcaption>
          </figure>
        ))}
      </div>
    </div>
  );
}

function SignalBreak({ images, reverse = false, code }) {
  return (
    <div className="signal-break" aria-hidden="true">
      <div className="signal-break-code">{code}</div>
      <SignalStrip images={images} reverse={reverse} label={code} />
    </div>
  );
}


function InteractiveGalaxy() {
  useEffect(() => {
    const root = document.documentElement;

    const handlePointerMove = (event) => {
      const x = event.clientX / window.innerWidth - 0.5;
      const y = event.clientY / window.innerHeight - 0.5;

      root.style.setProperty("--galaxy-x", `${x}`);
      root.style.setProperty("--galaxy-y", `${y}`);
      root.style.setProperty("--galaxy-pointer-x", `${event.clientX}px`);
      root.style.setProperty("--galaxy-pointer-y", `${event.clientY}px`);
    };

    const handlePointerLeave = () => {
      root.style.setProperty("--galaxy-x", "0");
      root.style.setProperty("--galaxy-y", "0");
      root.style.setProperty("--galaxy-pointer-x", "50vw");
      root.style.setProperty("--galaxy-pointer-y", "50vh");
    };

    window.addEventListener("pointermove", handlePointerMove, { passive: true });
    document.documentElement.addEventListener("mouseleave", handlePointerLeave);

    return () => {
      window.removeEventListener("pointermove", handlePointerMove);
      document.documentElement.removeEventListener("mouseleave", handlePointerLeave);
    };
  }, []);

  const stars = Array.from({ length: 115 }, (_, index) => {
    const left = (index * 47 + 13) % 100;
    const top = (index * 71 + 7) % 100;
    const size = 1 + ((index * 17) % 3);
    const opacity = 0.22 + ((index * 29) % 60) / 100;
    const delay = -((index * 31) % 90) / 10;
    const duration = 4.5 + ((index * 19) % 55) / 10;

    return (
      <span
        key={index}
        className={`abg-galaxy-star abg-galaxy-star-${index % 3}`}
        style={{
          left: `${left}%`,
          top: `${top}%`,
          width: `${size}px`,
          height: `${size}px`,
          opacity,
          animationDelay: `${delay}s`,
          animationDuration: `${duration}s`,
        }}
      />
    );
  });

  return (
    <div className="abg-galaxy" aria-hidden="true">
      <div className="abg-galaxy-nebula abg-galaxy-nebula-a" />
      <div className="abg-galaxy-nebula abg-galaxy-nebula-b" />
      <div className="abg-galaxy-nebula abg-galaxy-nebula-c" />
      <div className="abg-galaxy-stars abg-galaxy-stars-far">{stars.slice(0, 45)}</div>
      <div className="abg-galaxy-stars abg-galaxy-stars-mid">{stars.slice(45, 85)}</div>
      <div className="abg-galaxy-stars abg-galaxy-stars-near">{stars.slice(85)}</div>
      <div className="abg-galaxy-pointer-glow" />
      <div className="abg-galaxy-dust" />
    </div>
  );
}

export default function Landing() {
  const [originFolderOpen, setOriginFolderOpen] = useState(false);
  const [originPage, setOriginPage] = useState(-1);
  const [arrivalSignatureVisible, setArrivalSignatureVisible] = useState(false);
  const [detectionComplete, setDetectionComplete] = useState(false);
  const [welcomeVisible, setWelcomeVisible] = useState(false);
  const [arrivalIntroComplete, setArrivalIntroComplete] = useState(false);

  useEffect(() => {
    if (!detectionComplete) return;

    const welcomeTimer = window.setTimeout(() => {
      setWelcomeVisible(true);
    }, 4000);

    return () => window.clearTimeout(welcomeTimer);
  }, [detectionComplete]);


  useEffect(() => {
    if (!arrivalSignatureVisible) return;

    const unlockTimer = window.setTimeout(() => {
      setArrivalIntroComplete(true);
    }, 2200);

    return () => window.clearTimeout(unlockTimer);
  }, [arrivalSignatureVisible]);

  const openOriginFolder = () => {
    setOriginFolderOpen(true);
    setOriginPage(-1);
  };

  const selectOriginFile = (index) => {
    setOriginFolderOpen(true);
    setOriginPage(index);
  };

  const nextOriginPage = () => {
    setOriginPage((current) => Math.min(current + 1, originRecords.length - 1));
  };

  const previousOriginPage = () => {
    setOriginPage((current) => Math.max(current - 1, -1));
  };

  const closeOriginFolder = () => {
    setOriginFolderOpen(false);
    setOriginPage(-1);
  };

  return (
    <div
      data-testid="landing-page"
      className="min-h-screen bg-[#050505] noise-bg text-[#E5E5E5]"
    >
      <Navigation />
      <InteractiveGalaxy />

      <style>{`

        :root {
          --galaxy-x: 0;
          --galaxy-y: 0;
          --galaxy-pointer-x: 50vw;
          --galaxy-pointer-y: 50vh;
        }

        .abg-galaxy {
          position: fixed;
          inset: 0;
          z-index: 0;
          overflow: hidden;
          pointer-events: none;
          background:
            radial-gradient(circle at 18% 22%, rgba(89, 70, 170, 0.11), transparent 32%),
            radial-gradient(circle at 78% 68%, rgba(50, 168, 178, 0.08), transparent 34%),
            linear-gradient(180deg, rgba(5, 5, 5, 0.18), rgba(5, 5, 5, 0.02));
        }

        .abg-galaxy-nebula {
          position: absolute;
          border-radius: 50%;
          filter: blur(70px);
          opacity: 0.34;
          will-change: transform;
        }

        .abg-galaxy-nebula-a {
          width: 52vw;
          height: 52vw;
          left: -16vw;
          top: 4vh;
          background: radial-gradient(circle, rgba(113, 84, 214, 0.30), rgba(82, 66, 160, 0.08) 48%, transparent 72%);
          transform: translate(calc(var(--galaxy-x) * -22px), calc(var(--galaxy-y) * -18px));
          animation: abgNebulaDriftA 24s ease-in-out infinite alternate;
        }

        .abg-galaxy-nebula-b {
          width: 48vw;
          height: 48vw;
          right: -14vw;
          top: 30vh;
          background: radial-gradient(circle, rgba(65, 190, 198, 0.20), rgba(74, 125, 190, 0.07) 48%, transparent 72%);
          transform: translate(calc(var(--galaxy-x) * 28px), calc(var(--galaxy-y) * 20px));
          animation: abgNebulaDriftB 29s ease-in-out infinite alternate;
        }

        .abg-galaxy-nebula-c {
          width: 38vw;
          height: 38vw;
          left: 34vw;
          bottom: -18vw;
          background: radial-gradient(circle, rgba(142, 111, 224, 0.16), rgba(71, 179, 181, 0.06) 48%, transparent 72%);
          transform: translate(calc(var(--galaxy-x) * -16px), calc(var(--galaxy-y) * 24px));
          animation: abgNebulaDriftC 33s ease-in-out infinite alternate;
        }

        .abg-galaxy-stars {
          position: absolute;
          inset: -4%;
          will-change: transform;
        }

        .abg-galaxy-stars-far {
          transform: translate(calc(var(--galaxy-x) * -7px), calc(var(--galaxy-y) * -5px));
        }

        .abg-galaxy-stars-mid {
          transform: translate(calc(var(--galaxy-x) * -15px), calc(var(--galaxy-y) * -11px));
        }

        .abg-galaxy-stars-near {
          transform: translate(calc(var(--galaxy-x) * -27px), calc(var(--galaxy-y) * -20px));
        }

        .abg-galaxy-star {
          position: absolute;
          display: block;
          border-radius: 50%;
          background: rgba(235, 250, 255, 0.95);
          box-shadow: 0 0 7px rgba(165, 226, 255, 0.42);
          animation: abgStarPulse 6s ease-in-out infinite;
        }

        .abg-galaxy-star-1 {
          background: rgba(202, 192, 255, 0.92);
          box-shadow: 0 0 8px rgba(159, 139, 255, 0.38);
        }

        .abg-galaxy-star-2 {
          background: rgba(191, 255, 248, 0.90);
          box-shadow: 0 0 8px rgba(105, 231, 218, 0.34);
        }

        .abg-galaxy-pointer-glow {
          position: absolute;
          width: 34rem;
          height: 34rem;
          left: var(--galaxy-pointer-x);
          top: var(--galaxy-pointer-y);
          border-radius: 50%;
          transform: translate(-50%, -50%);
          background: radial-gradient(circle, rgba(130, 111, 220, 0.10), rgba(74, 185, 197, 0.045) 36%, transparent 70%);
          filter: blur(10px);
          transition: left 90ms linear, top 90ms linear;
        }

        .abg-galaxy-dust {
          position: absolute;
          inset: -20%;
          opacity: 0.20;
          background-image:
            radial-gradient(circle, rgba(255,255,255,0.32) 0 0.7px, transparent 0.9px),
            radial-gradient(circle, rgba(173,218,255,0.22) 0 0.6px, transparent 0.8px);
          background-size: 83px 83px, 127px 127px;
          background-position: 0 0, 31px 47px;
          transform: translate(calc(var(--galaxy-x) * -5px), calc(var(--galaxy-y) * -4px));
          animation: abgDustDrift 55s linear infinite;
        }

        .abg-section,
        .signal-break,
        footer,
        .abg-arrival {
          position: relative;
          z-index: 1;
        }

        @keyframes abgStarPulse {
          0%, 100% { filter: brightness(0.72); transform: scale(0.82); }
          48% { filter: brightness(1.35); transform: scale(1.18); }
          55% { filter: brightness(0.9); transform: scale(0.95); }
        }

        @keyframes abgNebulaDriftA {
          from { margin-left: -2vw; margin-top: -2vh; }
          to { margin-left: 5vw; margin-top: 7vh; }
        }

        @keyframes abgNebulaDriftB {
          from { margin-right: -3vw; margin-top: 3vh; }
          to { margin-right: 4vw; margin-top: -6vh; }
        }

        @keyframes abgNebulaDriftC {
          from { margin-left: -3vw; margin-bottom: -2vh; }
          to { margin-left: 4vw; margin-bottom: 6vh; }
        }

        @keyframes abgDustDrift {
          from { background-position: 0 0, 31px 47px; }
          to { background-position: 166px 83px, -96px 174px; }
        }

        @media (prefers-reduced-motion: reduce) {
          .abg-galaxy-nebula,
          .abg-galaxy-star,
          .abg-galaxy-dust {
            animation: none !important;
          }

          .abg-galaxy-stars,
          .abg-galaxy-nebula,
          .abg-galaxy-dust {
            transform: none !important;
          }
        }

        .abg-arrival-kicker.abg-detection-loading::after {
          content: "▌";
          display: inline-block;
          margin-left: 0.18em;
          animation: abgDetectionCursorBlink 0.72s steps(1, end) infinite;
        }

        .abg-welcome-pop {
          animation: abgWelcomePop 180ms ease-out both;
        }

        @keyframes abgDetectionCursorBlink {
          0%, 49% { opacity: 1; }
          50%, 100% { opacity: 0; }
        }

        @keyframes abgWelcomePop {
          from { opacity: 0; transform: scale(0.985); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>

      <section className="abg-arrival" aria-labelledby="abg-welcome-title">
        <div className="abg-arrival-stars" aria-hidden="true" />

        <div className="abg-arrival-inner">
          <p className={`abg-arrival-kicker ${detectionComplete && !welcomeVisible ? "abg-detection-loading" : ""}`}>
            <TypedArrivalText
              text="terrestrial.receiver // detected"
              enlargeWhileTyping={!welcomeVisible}
              startDelay={700}
              speed={115}
              onComplete={() => setDetectionComplete(true)}
              style={{ fontFamily: "'JetBrains Mono', monospace" }}
            />
          </p>

          {welcomeVisible && (
            <h1
              id="abg-welcome-title"
              className="abg-arrival-title abg-welcome-pop"
              style={{ fontFamily: "'Zen Dots', sans-serif" }}
            >
              WELCOME, HUMANOID.
            </h1>
          )}

          {welcomeVisible && (
            <p className="abg-arrival-subtitle">
              <TypedArrivalText
                text="YOU HAVE ENTERED THE WORLD OF"
                startDelay={3000}
                speed={125}
                style={{
                  fontFamily: "'JetBrains Mono', monospace",
                  fontSize: "inherit",
                }}
                onComplete={() => setArrivalSignatureVisible(true)}
              />
            </p>
          )}

          {arrivalSignatureVisible && (
            <div
            className="abg-signature-stage abg-materialize-stage"
            aria-label="Astral Born Glitch signature"
          >
            <div className="abg-signature-static" aria-hidden="true">
              <img src="/abg/abg-signature-transparent.png" alt="" />
            </div>
            <div className="abg-signature-slice abg-signature-slice-1" aria-hidden="true">
              <img src="/abg/abg-signature-transparent.png" alt="" />
            </div>
            <div className="abg-signature-slice abg-signature-slice-2" aria-hidden="true">
              <img src="/abg/abg-signature-transparent.png" alt="" />
            </div>
            <div className="abg-signature-slice abg-signature-slice-3" aria-hidden="true">
              <img src="/abg/abg-signature-transparent.png" alt="" />
            </div>
            <div className="abg-signature-slice abg-signature-slice-4" aria-hidden="true">
              <img src="/abg/abg-signature-transparent.png" alt="" />
            </div>
            <div className="abg-signature-ghost abg-signature-ghost-a" aria-hidden="true">
              <img src="/abg/abg-signature-transparent.png" alt="" />
            </div>
            <div className="abg-signature-ghost abg-signature-ghost-b" aria-hidden="true">
              <img src="/abg/abg-signature-transparent.png" alt="" />
            </div>

            <img
              src="/abg/abg-signature-transparent.png"
              alt="Astral Born Glitch signature"
              className="abg-signature-materialized"
            />

            <span className="abg-materialize-star" aria-hidden="true" />
            <span className="abg-materialize-wave" aria-hidden="true" />
          </div>
          )}

          <div className="abg-arrival-scroll" aria-hidden="true">
            <span />
            <span />
          </div>
        </div>
      </section>


      <section
        id="receive"
        className="min-h-screen flex items-center border-b border-white/5 abg-section abg-section-receive"
      >
        <div className="abg-section-ghost" aria-hidden="true">
          <img src="/abg/Channel%20Zero%20The%20Glitch.png" alt="" />
        </div>

        <div className="w-full px-6 sm:px-10 md:px-16 lg:px-24 py-24">
          <div className="max-w-5xl mx-auto relative">
            <p
              className="text-xs tracking-[0.25em] text-[#999] uppercase mb-5"
              style={{ fontFamily: "'Azeret Mono', monospace" }}
            >
              incoming.signal
            </p>

            <h1
              className="text-5xl sm:text-7xl md:text-8xl lg:text-9xl font-black tracking-tighter uppercase glitch-text"
              data-text="RECEIVE"
              style={{ fontFamily: "'Zen Dots', sans-serif" }}
            >
              RECEIVE
            </h1>

            <div className="mt-10 w-full h-[1px] bg-white/10" />

            <p
              className="mt-8 text-sm tracking-[0.18em] text-[#AAAAAA] uppercase"
              style={{ fontFamily: "'Bruno Ace SC', sans-serif" }}
            >
              CHOOSE YOUR RECEIVER
            </p>

            <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-4">
              {receivers.map((receiver) => (
                <a
                  key={receiver.platform}
                  href={receiver.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group border border-white/10 px-6 py-6 transition-all duration-300 hover:border-white/40 hover:bg-white/[0.03]"
                >
                  <div className="flex items-center justify-between gap-6">
                    <div>
                      <p
                        className="text-sm sm:text-base font-bold tracking-[0.16em] text-[#D8D8D8] uppercase transition-colors duration-300 group-hover:text-white"
                        style={{ fontFamily: "'Bruno Ace SC', sans-serif" }}
                      >
                        {receiver.name}
                      </p>
                      <p
                        className="mt-2 text-[11px] tracking-[0.18em] text-[#999] uppercase"
                        style={{ fontFamily: "'JetBrains Mono', monospace" }}
                      >
                        ({receiver.platform})
                      </p>
                    </div>
                    <span
                      className="text-[#888] text-lg transition-all duration-300 group-hover:text-white group-hover:translate-x-1"
                      aria-hidden="true"
                    >
                      →
                    </span>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>

      <SignalBreak
        images={receiveImages}
        code="// VISUAL SIGNAL CACHE 01 // RECEIVER BLEED"
      />

      <section id="origin-file" className="border-b border-white/5 abg-section abg-section-origin">
        <div className="abg-section-ghost abg-section-ghost-right" aria-hidden="true">
          <img src="/abg/Human%20Suit%20Disengaged.png" alt="" />
        </div>

        <div className="w-full px-6 sm:px-10 md:px-16 lg:px-24 py-24 sm:py-32">
          <div className="max-w-5xl mx-auto relative">
            <p
              className="text-xs tracking-[0.25em] text-[#999] uppercase mb-5"
              style={{ fontFamily: "'Azeret Mono', monospace" }}
            >
              recovered.data
            </p>

            <h2
              className="text-5xl sm:text-7xl md:text-8xl lg:text-9xl font-black tracking-tighter uppercase glitch-text"
              data-text="ORIGIN FILE"
              style={{ fontFamily: "'Zen Dots', sans-serif" }}
            >
              ORIGIN FILE
            </h2>

            <div className="mt-10 w-full h-[1px] bg-white/10" />

            <div
              className="mt-8 flex flex-wrap gap-x-8 gap-y-2 text-[11px] sm:text-xs tracking-[0.16em] text-[#888] uppercase"
              style={{ fontFamily: "'JetBrains Mono', monospace" }}
            >
              <span>ENTITY: ASTRAL BORN GLITCH</span>
              <span>ORIGIN: OFF-WORLD</span>
              <span>STATUS: STRANDED</span>
            </div>

            <div className="origin-folder-shell">
              {!originFolderOpen ? (
                <button
                  type="button"
                  className="origin-folder-closed"
                  onClick={openOriginFolder}
                  aria-label="Open recovered Origin File folder"
                >
                  <span className="origin-folder-stamp">RECOVERED // 08 FILES</span>
                  <span className="origin-folder-name">ASTRAL BORN GLITCH</span>
                </button>
              ) : (
                <div className="origin-folder-open">
                  <button
                    type="button"
                    className="origin-folder-close-zone"
                    onClick={closeOriginFolder}
                    aria-label="Close Origin File folder"
                  >
                    <span>CLICK FOLDER TO CLOSE</span>
                  </button>

                  <div className="origin-folder-spine" aria-hidden="true" />

                  <div className="origin-folder-tabs" role="tablist" aria-label="Origin file tabs">
                    {originRecords.map((record, index) => (
                      <button
                        type="button"
                        role="tab"
                        aria-selected={originPage === index}
                        className={`origin-folder-tab ${originPage === index ? "origin-folder-tab-active" : ""}`}
                        key={record.code}
                        onClick={() => selectOriginFile(index)}
                      >
                        {record.code}
                      </button>
                    ))}
                  </div>

                  <div className="origin-folder-left">
                    <button
                      type="button"
                      className="origin-folder-left-close"
                      onClick={closeOriginFolder}
                      aria-label="Close Origin File folder"
                    >
                    </button>

                    {originPage >= 0 ? (
                      <button
                        type="button"
                        className="origin-left-page-button"
                        onClick={previousOriginPage}
                        aria-label={originPage === 0 ? "Return introduction page to the right" : `Return ${originRecords[originPage - 1].code} to the right`}
                      >
                        <div className="origin-left-paper-stack" aria-hidden="true">
                          {Array.from({ length: originPage + 1 }, (_, stackIndex) => (
                            <div
                              key={stackIndex}
                              className="origin-paper origin-paper-left origin-paper-blank-back origin-paper-stack-sheet"
                              style={{
                                "--stack-index": stackIndex,
                                "--stack-count": originPage + 1,
                              }}
                            >
                              {stackIndex === originPage && (
                                <span className="origin-paper-back-mark">
                                  REVERSE // {originPage === 0 ? "INTRODUCTION" : originRecords[originPage - 1].code}
                                </span>
                              )}
                            </div>
                          ))}
                        </div>
                      </button>
                    ) : (
                      <div className="origin-folder-left-empty">RECOVERED MATERIAL</div>
                    )}
                  </div>

                  <div className="origin-folder-right">
                    {originPage === -1 ? (
                      <button
                        type="button"
                        className="origin-paper origin-paper-current origin-paper-intro"
                        onClick={nextOriginPage}
                        aria-label="Turn introduction page and open File 01"
                      >
                        <p className="origin-paper-label">RECOVERED INTRODUCTION</p>
                        <p className="origin-intro-lead">
                          I suppose if you're receiving my transmissions, you deserve to know where they're coming from.
                        </p>
                        <p>There are pieces of this story I remember clearly.</p>
                        <p>Others exist only as fragments.</p>
                        <p>And some parts are simply gone.</p>
                        <p>This is what remains.</p>
                      </button>
                    ) : (
                      <article
                        className="origin-paper origin-paper-current origin-file-paper"
                        key={originRecords[originPage].code}
                      >
                        <header className="origin-file-paper-header">
                          <p className="origin-paper-label">
                            {originRecords[originPage].code} // {originRecords[originPage].heading}
                          </p>
                          {originRecords[originPage].date && (
                            <p className="origin-file-date">{originRecords[originPage].date}</p>
                          )}
                        </header>

                        <div className="origin-file-paper-body">
                          {originRecords[originPage].paragraphs.map((paragraph, index) => (
                            <p key={index}>{paragraph}</p>
                          ))}
                        </div>

                        <div className="origin-file-controls">
                          <span />
                          <span>
                            {String(originPage + 1).padStart(2, "0")} / {String(originRecords.length).padStart(2, "0")}
                          </span>
                          {originPage < originRecords.length - 1 ? (
                            <button type="button" onClick={nextOriginPage}>NEXT →</button>
                          ) : (
                            <span className="origin-file-complete">TRANSMISSION CONTINUES</span>
                          )}
                        </div>
                      </article>
                    )}
                  </div>
                </div>
              )}

              <div className="origin-folder-end-marker">
                // END OF RECOVERED ORIGIN FILE
              </div>
            </div>
          </div>
        </div>
      </section>

      <SignalBreak
        images={originImages}
        reverse
        code="// RECOVERED VISUAL DATA // ORIGIN FILE CORRUPTION"
      />

      <section id="transmit" className="min-h-screen flex items-center abg-section abg-section-transmit">
        <div className="abg-section-ghost" aria-hidden="true">
          <img src="/abg/Filtered%20Transmission.png" alt="" />
        </div>

        <div className="w-full px-6 sm:px-10 md:px-16 lg:px-24 py-24">
          <div className="max-w-5xl mx-auto relative">
            <p
              className="text-xs tracking-[0.25em] text-[#999] uppercase mb-5"
              style={{ fontFamily: "'Azeret Mono', monospace" }}
            >
              outgoing.signal
            </p>

            <h2
              className="text-5xl sm:text-7xl md:text-8xl lg:text-9xl font-black tracking-tighter uppercase glitch-text"
              data-text="TRANSMIT"
              style={{ fontFamily: "'Zen Dots', sans-serif" }}
            >
              TRANSMIT
            </h2>

            <div className="mt-10 w-full h-[1px] bg-white/10" />

            <p
              className="mt-8 text-sm tracking-[0.18em] text-[#AAAAAA] uppercase"
              style={{ fontFamily: "'Bruno Ace SC', sans-serif" }}
            >
              OPEN TRANSMISSION
            </p>

            <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-4">
              {transmissionChannels.map((channel) => (
                <a
                  key={channel.platform}
                  href={channel.url}
                  target={channel.external ? "_blank" : undefined}
                  rel={channel.external ? "noopener noreferrer" : undefined}
                  className="group border border-white/10 px-6 py-6 transition-all duration-300 hover:border-white/40 hover:bg-white/[0.03]"
                >
                  <div className="flex items-center justify-between gap-6">
                    <div>
                      <p
                        className="text-sm sm:text-base font-bold tracking-[0.14em] text-[#D8D8D8] uppercase transition-colors duration-300 group-hover:text-white"
                        style={{ fontFamily: "'Bruno Ace SC', sans-serif" }}
                      >
                        {channel.name}
                      </p>
                      <p
                        className="mt-2 text-[11px] tracking-[0.18em] text-[#999] uppercase"
                        style={{ fontFamily: "'JetBrains Mono', monospace" }}
                      >
                        ({channel.platform})
                      </p>
                    </div>
                    <span
                      className="text-[#888] text-lg transition-all duration-300 group-hover:text-white group-hover:translate-x-1"
                      aria-hidden="true"
                    >
                      →
                    </span>
                  </div>
                </a>
              ))}
            </div>

            <p
              className="mt-10 text-xs sm:text-sm leading-6 tracking-[0.12em] text-[#888] uppercase"
              style={{ fontFamily: "'JetBrains Mono', monospace" }}
            >
              ALL TRANSMISSIONS MAY BE RECEIVED. NOT ALL TRANSMISSIONS WILL
              RECEIVE A RESPONSE.
            </p>
          </div>
        </div>
      </section>

      <SignalBreak
        images={transmitImages}
        code="// OUTGOING VISUAL SIGNAL // TRANSMISSION CONTINUES"
      />

      <footer className="border-t border-white/5 px-6 py-6">
        <div className="max-w-5xl mx-auto flex items-center justify-between">
          <p
            className="text-[11px] text-[#666] tracking-[0.16em] uppercase"
            style={{ fontFamily: "'JetBrains Mono', monospace" }}
          >
            signal.integrity = unstable
          </p>
          <p
            className="text-[11px] text-[#666] tracking-[0.16em]"
            style={{ fontFamily: "'JetBrains Mono', monospace" }}
          >
            ABG.
          </p>
        </div>
      </footer>
    </div>
  );
}
